module.exports = __webpack_public_path__ + "static/media/091-play button.c47a58aa.svg";